module.exports = __webpack_public_path__ + "assets/img/ed0e-to.svg";